// nav
let mainContainer = document.querySelector('.main-container') as HTMLElement
if (mainContainer){
    let prevScrollpos: number = mainContainer.scrollTop;
    mainContainer.addEventListener('scroll', () => {
        let currentScrollPos: number = mainContainer.scrollTop;
    
        const hamburgerElement = document.querySelector('.hamburger-btn') as HTMLElement;
    
        if (hamburgerElement) {
            if (prevScrollpos > currentScrollPos) {
                // Scrolling up
                hamburgerElement.style.opacity = '1';
                hamburgerElement.style.pointerEvents = 'auto';
            } else {
                // Scrolling down
                hamburgerElement.style.opacity = '0';
                hamburgerElement.style.pointerEvents = 'none';
            }
        }
    
        prevScrollpos = currentScrollPos;
    })
}